import React from "react";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import SoftBox from "components/SoftBox";
import PropTypes from "prop-types";

const SortIcon = ({ orderDirection, isActive }) => {
  const iconStyle = {
    fontSize: "14px",
    color: "secondary.main",
    transition: "color 0.2s ease",
  };

  // Only show icon if this column is actively sorted
  if (!isActive) {
    return null;
  }

  return (
    <SoftBox
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "14px",
        height: "14px",
      }}
    >
      <ArrowUpward
        sx={{
          ...iconStyle,
          color: orderDirection === "asc" && isActive ? "dark.main" : "secondary.main",
        }}
      />
      <ArrowDownward
        sx={{
          ...iconStyle,
          color: orderDirection === "desc" && isActive ? "dark.main" : "secondary.main",
        }}
      />
    </SoftBox>
  );
};

SortIcon.propTypes = {
  orderDirection: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default SortIcon;
